import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ConfigService } from 'src/app/shared/config';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductService } from '../product/product.service';
import { combineLatest, Subject, Subscription, Observable } from 'rxjs';
import { map, startWith, flatMap } from 'rxjs/operators';
import { SystemService } from '../../services/system.service';
import { CompanysitesService } from '../company-sites/company-sites.service';
import { MembershipV2Service } from '../../services/membership-v2.service';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import {  MatSelectChange } from '@angular/material/select';
import { Moment } from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';



@Component({
  selector: 'app-report-generator',
  templateUrl: './report-generator.component.html',
  styleUrls: ['./report-generator.component.css'],
})



export class ReportGeneratorComponent implements OnInit, OnDestroy {

  public todayDate = new Date();
  public siteId: string;

  inputDateFrom: Date;
  inputDateTo: Date;

  timeSelected: string = "TODAY";
  product$;
  productFilter$ = new Subject()
  filteredProduct$;

  employees$;
  employeesFilter$ = new Subject()
  filteredemployees$;

  department$;
  departmentFilter$ = new Subject()
  filteredDepartment$;

  projects$;
  projectsFilter$ = new Subject()
  filteredProjects$;

  systems$;
  systemsFilter$ = new Subject()
  filteredSystems$;

  employeeId;
  productId;
  projectId;
  systemId;
  departmentId;

  siteData$: Observable<any>;
  employeeName;
  productName;
  projectName;
  systemName;
  departmentName;
  siteName;
  focus = "ALL";
  filterString = "";
  filteredStatesSub: Subscription;
  timer;
  searchResultReceived = false;

  // Datetime picker settings
  newdate: Date = new Date();
  settings = {
    bigBanner: true,
    timePicker: true,
    format: 'dd-MMM-yyyy hh:mm',
    defaultOpen: false
  }

  constructor(private config: ConfigService,
    private route: ActivatedRoute,
    private router: Router,
    private productService: ProductService,
    private siteService: CompanysitesService,
    private membershipV2: MembershipV2Service
  ) {
    this.productService.getProducts();

    this.route.parent.params.subscribe(params => {
      this.siteId = params['siteId']
    })

    this.siteData$ = this.route.parent.params.pipe(flatMap(params => this.siteService.getSiteById(params['siteId']).pipe(map(value => { 
      return { 
        name: value.data()['name'], 
        siteId: params['siteId'], 
        isDepartmentActive: value.data()['isDepartmentActive'],  
        isProjectActive: value.data()['isProjectActive'],
        strictGroup: value.data()['strictGroup'],
      };
    }))))

  }


  ngOnDestroy(): void {
    if(this.filteredStatesSub) this.filteredStatesSub.unsubscribe();
  }

  onSubmit(form) {
    console.log(form)
    console.log("from", moment(this.inputDateFrom.valueOf()))
    console.log("to", moment(this.inputDateTo.valueOf()))
    console.log("from unix", moment(this.inputDateFrom.valueOf()).unix())
    console.log("to unix", moment(this.inputDateTo.valueOf()).unix())

    console.log("Serch date:", moment(this.inputDateFrom).tz("America/Los_Angeles").format());
    this.router.navigate(['../report'], { relativeTo: this.route })
    setTimeout(() => {
      this.router.navigate(['generate'], {
        queryParams:
        {
          projectId: this.projectId,
          employeeId: this.employeeId,
          productId: this.productId,
          systemId: this.systemId,
          departmentId: this.departmentId,
          focusBy: this.focus,

          // projectName: this.projectName,
          // employeeName: this.employeeName,
          // productName: this.productName,
          // systemName: this.systemName,
          // departmentName: this.departmentName,

          dateFrom: moment(this.inputDateFrom).tz("Europe/Oslo").unix(),
          dateTo: moment(this.inputDateTo).tz("Europe/Oslo").unix(),
          siteId: this.siteId,
          siteName: this.siteName,
          companyId: this.config.getCompanyId()
        }, relativeTo: this.route
      })
    }, 200)

  }
  async ngOnInit() {

    this.setTimePeriode('TODAY');
    // this.product$ = this.productService.getProducts();
    this.product$ = this.productService.data;

    this.filteredProduct$ = combineLatest(
      this.product$, this.productFilter$.pipe(startWith(""))).pipe(map(([data, filter]) => {
        if (this.filterString != filter) {
          this.searchResultReceived = false;
        }
        this.filterString = filter as string;

        console.log(filter)
        return ((data as Array<{}>).filter(option => option['productNumberLowerCase'].toLowerCase().includes(filter))) ||
          ((data as Array<{}>).filter(option => option['searchString'].toLowerCase().includes(filter)))

      }))

    this.filteredStatesSub = this.filteredProduct$.subscribe(data => {
      if (this.filterString.length > 2 && !this.searchResultReceived) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.productService.getProductByNameAndPartNumber(this.filterString);
          this.searchResultReceived = true;


        }, 1000)
      }
    })

    // The site's v2 memberships; employeeCode is the employee number.
    this.employees$ = this.membershipV2.getMemberships$(this.siteId)
      .pipe(map((list: any[]) => list.map(m => ({ ...m, employeeId: m.employeeCode || '' }))));

    this.filteredemployees$ = combineLatest(
      this.employees$, this.employeesFilter$.pipe(startWith(""))).pipe(map(([data, filter]) => {
        return (data as Array<{}>).filter(option => option['name'] ? option['name'].toLowerCase().includes(filter) : "")
      }))



    this.systems$ = this.siteService.getSiteSystemsByIdObs(this.siteId);

    this.filteredSystems$ = combineLatest(
      this.systems$, this.systemsFilter$.pipe(startWith(""))).pipe(map(([data, filter]) => {
        return (data as Array<{}>).filter(option => option['name'].toLowerCase().includes(filter))
      }))

  }

  setTimePeriodeEvent(event: MatSelectChange) {
    this.setTimePeriode(event.value);
  }

  setTimePeriode(value) {
    try {

      const now = moment();

      let from: Moment;
      let to: Moment;
      console.log(value)
      switch (value) {
        case 'TODAY':
          from = moment(now).startOf('day');
          to = now.endOf('day');
          break;
        case 'YESTERDAY':
          from = moment(now).subtract(1, 'days').startOf('day');
          to = moment(from).endOf('day');
          break;
        case '24H':
          from = moment(now).subtract(1, 'days');
          to = moment(now);
          break;
        case 'THIS_MONTH':
          from = moment(now).startOf('month');
          to = moment(now).endOf('day');
          break;
        case 'LAST_MONTH':
          from = moment(now).subtract(1, 'month').startOf('month');
          to = moment(from).endOf('month');
          break;
        case 'CUSTOM':
          return;
          break;
        default:
          throw new Error("Unhandled select time case!")
      }

      this.inputDateFrom = from.toDate();
      this.inputDateTo = to.toDate();

      console.log("from", this.inputDateFrom)
      console.log("to", this.inputDateTo)

    } catch (err) {
      console.log(err.message)
    }

  }

  applyProductFilter(filterValue: string) {
    this.productFilter$.next(filterValue.toLowerCase());
  }

  applyEmployeeFilter(filterValue: string) {
    this.employeesFilter$.next(filterValue.toLowerCase());
  }

  applyProjectFilter(filterValue: string) {
    this.projectsFilter$.next(filterValue.toLowerCase());
  }

  applySystemFilter(filterValue: string) {
    this.systemsFilter$.next(filterValue.toLowerCase());
  }

  applyDepartmentFilter(filterValue: string) {
    this.departmentFilter$.next(filterValue.toLowerCase());
  }


  onReset(form) {
    // this.employeeId = "";
    // this.productId = "";
    // this.projectId = "";
    // this.systemId = "";
    // this.router.navigate(['../report'], { relativeTo: this.route })
  }

  setProject(obj) {
    console.log(obj)
    if (obj === '') {
      this.projectId = "";
      this.projectName = ""
      return
    }
    this.projectId = obj.dbid;
    this.projectName = obj.name

  }
  setEmployee(obj) {
    if (obj === '') {
      this.employeeId = "";
      this.employeeName = ""
      return
    }
    this.employeeId = obj.employeeId;
    this.employeeName = obj.name
  }
  setProduct(obj) {
    if (obj === '') {
      this.productId = "";
      this.productName = ""
      return
    }
    this.productId = obj.id;
    this.productName = obj.name
  }
  setSystem(obj) {
    if (obj === '') {
      this.systemId = "";
      this.systemName = ""
      return
    }
    this.systemId = obj.systemId;
    this.systemName = obj.name
  }
  setDepartment(obj) {
    if (obj === '') {
      this.departmentId = "";
      this.departmentName = ""
      return
    }
    this.departmentId = obj.dbid;
    this.departmentName = obj.name
  }

  setCustomRange(event: MatDatepickerInputEvent<Date>, picker: 'start' | 'end') {

    if (picker === 'start') {
      this.inputDateFrom = moment(event.value).startOf('day').toDate();
    } else {
      this.inputDateTo = moment(event.value).endOf('day').toDate()
    }
  }

  changeFocus(value) {
    console.log(value)
    this.focus = value;
  }
}
